import { useTranslation } from 'react-i18next';

import { Spinner } from '@chakra-ui/react';

interface OverlayLoaderProps {
  isVisible: boolean;
  label?: string;
  message?: string;
}

const stylesheet = {
  overlay:
    'z-1700 fixed inset-0 w-full h-full bg-semantic-bg-surface flex flex-col justify-center items-center',
  // Fixed line-heights + reserved min-heights (and a width cap on the message)
  // so neither a web-font swap nor the i18n text resolving late can change this
  // block's height and re-center it. That re-centering was the dominant ~0.09
  // CLS shift, because this loader is the Suspense fallback shown on every route
  // while its lazy chunk loads (and it was also the LCP element).
  heading:
    'mt-4 mb-2 text-[20px] font-medium leading-7 text-center min-h-[28px]',
  message:
    'text-semantic-text-secondary leading-5 text-center max-w-[280px] min-h-[40px]',
};

export function OverlayLoader({
  isVisible,
  label,
  message,
}: Readonly<OverlayLoaderProps>) {
  const { t } = useTranslation();

  if (!isVisible) return null;

  return (
    <div className={stylesheet.overlay}>
      <Spinner
        thickness="4px"
        size="xl"
        variant="emerald"
        w={'48px'}
        h={'48px'}
      />
      <h1 className={stylesheet.heading}>
        {label ?? t('common.loading.label')}
      </h1>
      <p className={stylesheet.message}>
        {message ?? t('common.loading.message')}
      </p>
    </div>
  );
}
